import { Monitor } from 'lucide-react';
import { Alert } from '@parsina/framework';
import { useTranslation } from '../i18n';

/**
 * The one sanctioned way to say a capability is desktop-first.
 *
 * The scope ladder allows a multi-field definition task — insurance coverage
 * rules, a service's cost model, a role's permission matrix, purchase entry —
 * to stay on the workstation. What it does not allow is that capability being
 * SILENTLY missing: an operator who cannot find a thing they used yesterday
 * assumes the app is broken, and files a bug about a decision.
 *
 * So absence is stated, in the shape the app already uses
 * (`operations.desktopOnly.notice`). It is never a disabled button — a control
 * that can never be pressed on this device is furniture — and never a toast,
 * because the fact is permanent and a toast expires.
 *
 * Note the distinction it must NOT be used for: a capability the VIEWER lacks
 * permission for is absent with no note at all. Telling someone a section
 * exists that they may never open is worse than not mentioning it.
 */
export default function MobileDesktopNote({ what, style, 'data-testid': testId }) {
  const { t } = useTranslation();
  return (
    <Alert
      variant="neutral"
      icon={<Monitor size={16} aria-hidden="true" />}
      style={style}
      data-testid={testId || 'mobile-desktop-note'}
    >
      {t('operations.desktopOnly.notice', { what })}
    </Alert>
  );
}
